export type MissingObject =
  | "TEMPLATE"
  | "FORM"
  | "CATEGORY"
  | "SECTION"
  | "ITEM"
  | "TASK";

export class MissingError extends Error {
  public readonly name: string = "MissingError";
  public object: MissingObject;
  public id: number;

  constructor(message: string, object: MissingObject, id: number) {
    super(message);
    this.object = object;
    this.id = id;
  }
}
